import { useState } from 'react';
import { supabase } from '@/lib/supabase';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    setStatus('idle');
    setMessage('');
    try {
      const { data, error } = await supabase.functions.invoke('newsletter-subscribe', {
        body: { email: email.trim(), name: name.trim() || undefined },
      });
      if (error) throw error;
      const parsed = data as { ok?: boolean; message?: string; error?: string };
      if (parsed?.ok) {
        setStatus('success');
        setMessage(parsed.message ?? 'Inscrição realizada com sucesso!');
        setEmail('');
        setName('');
      } else {
        setStatus('error');
        setMessage(parsed?.error ?? 'Erro ao realizar inscrição.');
      }
    } catch (err) {
      setStatus('error');
      setMessage(err instanceof Error ? err.message : 'Erro ao realizar inscrição.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
      <div className="max-w-md">
        <h3 className="text-[#1D1D1F] font-semibold text-[17px] tracking-[-0.02em]">Novidades da HomeOffice Premium</h3>
        <p className="mt-1 text-[13px] text-[#6E6E73] leading-relaxed">
          Dicas de mobiliário corporativo e novos produtos, direto no seu e-mail.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="flex-1 max-w-lg" data-readdy-form="newsletter">
        <div className="flex flex-col sm:flex-row gap-2">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nome (opcional)"
            aria-label="Nome"
            className="sm:w-44 min-w-0 bg-white border border-black/[0.1] rounded-full px-4 py-2.5 text-[13px] text-[#1D1D1F] placeholder:text-[#6E6E73] focus:outline-none focus:border-[#E8610A]"
          />
          <div className="flex flex-1 min-w-0 gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              aria-label="E-mail"
              required
              className="flex-1 min-w-0 bg-white border border-black/[0.1] rounded-full px-4 py-2.5 text-[13px] text-[#1D1D1F] placeholder:text-[#6E6E73] focus:outline-none focus:border-[#E8610A]"
            />
            <button
              type="submit"
              disabled={busy || !email.trim()}
              className="inline-flex items-center justify-center bg-[#1D1D1F] text-white text-[13px] font-medium px-5 py-2.5 rounded-full hover:bg-black whitespace-nowrap disabled:opacity-40 shrink-0"
            >
              {busy ? <i className="ri-loader-4-line animate-spin"></i> : 'Inscrever'}
            </button>
          </div>
        </div>

        {status === 'success' && <p className="mt-2 text-[12px] text-[#1D7F3A]">{message}</p>}
        {status === 'error' && <p className="mt-2 text-[12px] text-[#C4302B]">{message}</p>}
        <p className="mt-2 text-[11px] text-[#6E6E73]">Você pode cancelar a qualquer momento.</p>
      </form>
    </div>
  );
}
